import { ReactElement } from 'react';
import { observer } from 'mobx-react-lite';
import styles from './accordion.module.scss';

export const Accordion = observer(
  ({ 
    children, 
    hasGradientBackground = true, 
    classes 
  }: { 
    children?: any;
    hasGradientBackground?: boolean; 
    classes?: string[] 
  }) => {
    return (
      <div className={[
        styles.accordionContainer,
        ...(classes ? classes : [])
      ].join(' ')}>
        {hasGradientBackground && (
          <>
            <div className={styles.overlayGradient}></div>
            <div className={styles.underlayGradient}></div>
          </>
        )}
        <ul>{children}</ul>
      </div>
    );
  }
);